// src/components/Layout/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaLinkedin,
  FaTwitter,
  FaInstagram,
} from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section company-info">
            <h3 className="footer-title">Falmouth Global Solutions</h3>
            <p className="footer-description">
              Your Premier Partner in Freight Shipping, Customs Clearance &
              Global Forwarding services in Kenya.
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>+254 723 335043</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>info@falmouth.co.ke</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>Nairobi, Kenya</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section quick-links">
            <h4 className="footer-subtitle">Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/" className="footer-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="footer-link">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="footer-link">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section services">
            <h4 className="footer-subtitle">Our Services</h4>
            <ul className="footer-links">
              <li>
                <span className="footer-link">Sea Freight Shipping</span>
              </li>
              <li>
                <span className="footer-link">Air Freight Services</span>
              </li>
              <li>
                <span className="footer-link">Road Transport</span>
              </li>
              <li>
                <span className="footer-link">Customs Clearance</span>
              </li>
              <li>
                <span className="footer-link">Warehousing</span>
              </li>
              <li>
                <span className="footer-link">Supply Chain Management</span>
              </li>
            </ul>
          </div>

          {/* Social & Locations */}
          <div className="footer-section social-locations">
            <h4 className="footer-subtitle">We Operate In</h4>
            <div className="locations">
              <div className="location-tag">Nairobi ICD</div>
              <div className="location-tag">Mombasa Port</div>
              <div className="location-tag">JKIA</div>
            </div>

            <h4 className="footer-subtitle social-title">Connect With Us</h4>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="#" className="social-link" aria-label="Instagram">
                <FaInstagram />
              </a>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © 2025 Falmouth Global Solutions. All Rights Reserved.
            </p>
            <div className="footer-bottom-links">
              <span>Privacy Policy</span>
              <span>Terms of Service</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
